import React, { useEffect, useState } from "react";
import { parse_url } from "../../../../../common/src";
import PreloaderIcon from "../Icons/PreloaderIcon";
import * as settingsConstants from "../../../../../cp/components/EventPage/Widgets/NewRegistration/constants";
import { hexToRgb } from '../../../../../platform/src/helpers/hexToRgb';

import "./style.scss";

const Preloader = () => {
    const request = parse_url(location.href);
    const [styles, setStyles] = useState({});

    useEffect(() => {
        const backgroundColor = hexToRgb(request?.getParameter('backgroundColor') ?? 'FFFFFF');

        setStyles({
            [settingsConstants.WIDGET_BACKGROUND_COLOR]: `rgba(${backgroundColor}, ${request?.getParameter('backgroundOpacityPercent')}%)`,
            [settingsConstants.WIDGET_ACCENT_COLOR]: request?.getParameter('colorAccent') ?? 'FF434C',
        })
    }, []);

    return (
        <div
            style={{backgroundColor: `${styles[settingsConstants.WIDGET_BACKGROUND_COLOR]}`}}
            className="preloader"
        >
            <div className="preloader__icon">
                <PreloaderIcon color={`#${styles[settingsConstants.WIDGET_ACCENT_COLOR]}`} />
            </div>
        </div>
    );
};

export default Preloader;
